import turfLineOffset from "@turf/line-offset";

/**
 * Offset a line feature left/right by a given distance.
 * @param {Feature<LineString>|LineString} feature
 * @param {number} distance Distance in the units of the input Feature/LineString
 * @param {object} options Turf optional params (units = 'kilometers', etc.)
 * @returns {Feature<LineString>} Offset line
 */
export default function lineOffset(feature, distance, options = {}) {
    if (!feature) {
        throw new Error("lineOffset: feature is required");
    }
    if (typeof distance !== "number") {
        throw new Error("lineOffset: distance must be a number");
    }

    return turfLineOffset(feature, distance, options);
}
